var COMPANY_PATH = "/company/:oid/";

angular.module('CarsSaraBo').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when(COMPANY_PATH, {
        templateUrl: 'assets/company/index.html',
        controller: 'CompanyController',
        title: 'company.TITLE',
        sidebar: 'company'
    });
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/routes/company_route.js
// module id = 811
// module chunks = 3